import $ from "jquery";

export default function addMap() {
  $(document).ready(() => {
    function newMap($el) {
      // var
      const $markers = $el.find(".marker");

      // vars
      const args = {
        zoom: 15,
        // center: new google.maps.LatLng(0, 0),
        center: new google.maps.LatLng(59.45100217897679, 24.736655123809946),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#e9e9e9",
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 29,
              },
              {
                weight: 0.2,
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 18,
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#dedede",
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                visibility: "on",
              },
              {
                color: "#ffffff",
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                saturation: 36,
              },
              {
                color: "#333333",
              },
              {
                lightness: 40,
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [
              {
                color: "#f2f2f2",
              },
              {
                lightness: 19,
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#fefefe",
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#fefefe",
              },
              {
                lightness: 17,
              },
              {
                weight: 1.2,
              },
            ],
          },
        ],
      };

      // create map
      const map = new google.maps.Map($el[0], args);

      // add a markers reference
      map.markers = [];

      // add markers
      $markers.each(function () {
        addMarker($(this), map);
      });

      // center map
      centerMap(map);

      // return
      return map;
    }

    function addMarker($marker, map) {
      // var
      const latlng = new google.maps.LatLng(
        $marker.attr("data-lat"),
        $marker.attr("data-lng")
      );

      const icon = {
        url: `${wordpress_localized_variables.template_url}/dist/static/map-pin.png`, // url
        scaledSize: new google.maps.Size(60, 60), // experiment with these values until you're satisfied
        origin: new google.maps.Point(0, 0), // set the base origin
        anchor: new google.maps.Point(0, 0), // set the base anchor
      };

      // create marker
      const marker = new google.maps.Marker({
        position: latlng,
        map,
        icon: icon,
      });

      // add to array
      map.markers.push(marker);

      // if marker contains HTML, add it to an infoWindow
      if ($marker.html()) {
        // create info window
        const infowindow = new google.maps.InfoWindow({
          content: $marker.html(),
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, "click", () => {
          infowindow.open(map, marker);
        });
      }
    }

    function centerMap(map) {
      // vars
      const bounds = new google.maps.LatLngBounds();

      // loop through all markers and create bounds
      $.each(map.markers, (i, marker) => {
        const latlng = new google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng()
        );

        bounds.extend(latlng);
      });

      // only 1 marker?
      if (map.markers.length == 1) {
        // set center of map
        // map.setCenter(bounds.getCenter());
        map.setZoom(15);
      } else {
        // fit to bounds
        map.fitBounds(bounds);
      }
    }
    // global var
    let map = null;

    $(document).ready(() => {
      $(".google-map").each(function createMap() {
        // create map
        map = newMap($(this));
      });
    });
  });
}
